export default __webpack_public_path__ + "static/media/new.99559f48.png";